import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TeacherService } from '../../serivce/teacher.service';
import { TicketService } from '../../serivce/ticket.service';


@Component({
  selector: 'app-ticket-delete-dialog',
  templateUrl: './ticket-delete-dialog.component.html',
  styleUrls: ['./ticket-delete-dialog.component.css']
})
export class TicketDeleteDialogComponent implements OnInit {
  datas: any;
  constructor(private spinner: NgxSpinnerService,

    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: TicketService,
    private dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
  ) {
    this.datas = data;
  }
  ngOnInit() {
  }
  deleteTicket() {
    debugger
    var model = {
      Id: this.datas.model.Id
    }
    this.spinner.show();
    this.service.delTicket(model).subscribe(res => {
      this.spinner.hide();
      if (res.status == 2) {
        this.toastr.success(res.content, "Thành công");
        this.dialogRef.close();
      }
      else {
        this.toastr.error(res.content, "Thành công");
      }

    })
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
